import React from 'react';
import PropTypes from 'prop-types';
import { withModalActions } from 'core/hocs';

import { MODAL_IDS } from 'src/constants';
import { ModalWindow } from '../../modal-window/modal-window';
import { FormProvidePhone } from '../../forms/form-provide-phone/form-provide-phone';

import './provide-phone-modal.scss';

export const ProvidePhoneModalUI = ({ closeModal, currentModal }) => {
  const { data } = currentModal;

  function onClosed() {
    closeModal(MODAL_IDS.PROVIDE_MOBILE_PHONE);
  }

  return (
    <ModalWindow
      id={MODAL_IDS.PROVIDE_MOBILE_PHONE}
      coreProps={{ id: MODAL_IDS.PROVIDE_MOBILE_PHONE }}
      onClosed={onClosed}
      bodyClassName="pt-9 pt-sm-5 pt-md-3_5 pb-3_75"
      fade
    >
      <FormProvidePhone
        coreProps={{ isEmptyDefaultValue: true, isIncludePhoneField: false }}
        isWithSaveOption={data?.isWithSaveOption}
      />
    </ModalWindow>
  );
};

ProvidePhoneModalUI.propTypes = {
  closeModal: PropTypes.func.isRequired,
  currentModal: PropTypes.shape().isRequired
};

export const ProvidePhoneModal = withModalActions(ProvidePhoneModalUI);
